module.exports = __webpack_public_path__ + "img/c-1.0fd46bb4.png";